import { Quote } from "lucide-react";

const QUOTES = [
    {
        text: "Najlepší nápoj, čo som mal v živote. Chutí, akoby ti niekto šepkal do ucha pravdu.",
        author: "Tester #1",
        role: "Prvá várka",
    },
    {
        text: "Otvoril som fľašu a stratil som kontrolu nad svojím týždňom. 10/10.",
        author: "Tester #2",
        role: "Edícia 1.0",
    },
    {
        text: "Toto nie je nápoj. Toto je vyhlásenie. A je SAKRA dobré.",
        author: "Tester #3",
        role: "Súrodenec autora",
    },
];

export const Testimonials = () => {
    return (
        <section
            data-testid="testimonials-section"
            className="relative px-6 sm:px-10 py-24 sm:py-32 border-t border-white/10"
        >
            <div className="max-w-[1400px] mx-auto">
                <div className="grid grid-cols-12 gap-10 mb-16">
                    <div className="col-span-12 lg:col-span-3">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-[#D91C1C]">
                            04 / Ozveny
                        </div>
                    </div>
                    <div className="col-span-12 lg:col-span-9">
                        <h2
                            data-testid="testimonials-heading"
                            className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.9] text-white"
                        >
                            Čo vraveli{" "}
                            <span className="text-white/40">prví odvážni</span>
                        </h2>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {QUOTES.map((q, idx) => (
                        <div
                            key={idx}
                            data-testid={`testimonial-${idx + 1}`}
                            className="relative bg-[#0A0A0A] border border-white/10 p-8 sm:p-10 hover:border-[#D91C1C]/40 transition-colors group"
                        >
                            <Quote
                                size={28}
                                className="text-[#D91C1C] mb-6"
                                strokeWidth={1.5}
                            />
                            <p className="text-lg text-white/85 leading-relaxed mb-8">
                                &bdquo;{q.text}&ldquo;
                            </p>
                            <div className="pt-6 border-t border-white/10">
                                <div className="font-display uppercase text-xl text-white tracking-tight">
                                    {q.author}
                                </div>
                                <div className="text-[10px] uppercase tracking-[0.25em] text-white/40 mt-1">
                                    {q.role}
                                </div>
                            </div>
                            {/* Subtle hover accent */}
                            <div className="absolute top-0 left-0 h-0.5 w-0 bg-[#D91C1C] group-hover:w-full transition-all duration-500" />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
